<template>
    <v-container>
        <p>
            Hubungi admin untuk mendapatkan bantuan.
        </p>

        <contact-list></contact-list>
    </v-container>
</template>

<script>
import ContactList from '@/components/home/ContactList'

export default {
    components: {
        ContactList,
    },

    data() {
        return {
            helps: null
        }
    },

    created() {
        this.$api.get('help')
            .then(response => {
                this.helps = response.data.helps
            })
    }
}
</script>
